import { Injectable } from "@angular/core";

export const enum BrowserFontSize
{
    Default = 16,
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    Medium = 16,
    Large = 20,
    VeryLarge = 24,
}

@Injectable()
export class BrowserService
{
    private _fontSetting: number = -1;

    get browserFontSetting(): number
    {
        if (this._fontSetting < 0)
        {
            const baseElement = document.querySelector("body");
            if (baseElement)
            {
                const compStyles = window.getComputedStyle(baseElement);
                this._fontSetting = parseInt(compStyles.getPropertyValue("font-size"));
            }
            else
            {
                this._fontSetting = BrowserFontSize.Default;
            }
        }

        return this._fontSetting;
    }

    get isBrowserFontSettingDefault(): boolean
    {
        return this.browserFontSetting === BrowserFontSize.Default;
    }
}
